﻿<template>
    <ProgressSpinner v-if="loading" class="center"
                     style="width:100px;height:100px; display:block;" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s" />
    <div class="p-blockui-mask p-overlay-mask p-overlay-mask-enter p-blockui-mask-document" v-if="loading"></div>
</template>

<style scoped>
    .center {
        position: absolute !important;
        margin: auto !important; /* 垂直置中元素 */
        top: 0 !important;
        bottom: 0 !important;
        left: 0 !important; /* 水平置中元素 */
        right: 0 !important;
    }
</style>

<script lang="ts">
    export default {
        name: module$.loading,
        inheritAttrs: true
    }
</script>

<script setup lang="ts">
    import { toRefs } from 'vue'
    import { module$ } from '../enums'

    const props = defineProps({
        //是否載入中
        loading: { type: Boolean, required: true, default: false }
    })

    //***************工具物件***************

    //***************元件屬性|計算**********
    const { loading } = toRefs(props);

    //***************元件函式***************

    //***************元件監看***************


    //***************元件鉤子***************

</script>
